import { autopilotCreditsShortfall } from '@/store/slices/blog-api';

export type AutopilotSettleInput = {
  /** The brand the blog slice asks under. */
  brandId: string | undefined;
  /** The brand on screen; it differs from the active one mid-switch. */
  displayBrandId: string | undefined;
  /** The open credits notice's price, or null when none is open (or none has been read). */
  needed: number | null;
  /** The owner's AI-credits balance, or null until the wallet has loaded. */
  balance: number | null;
  /** What one article costs now, when known. */
  price: number | null;
};

/**
 * When the studio should close an Autopilot credits notice on its own, as the
 * key the layout's watcher remembers (`useAutopilotCreditsSettle`), or null
 * when it should not: the active brand has a notice open, that brand is the
 * one on screen, and the owner's balance covers what the next article costs.
 *
 * The key names every value the decision was made on, so the watcher asks once
 * per state rather than once per render: a settle that failed is not retried
 * in a loop, and a later top-up (a new balance) is a new attempt.
 */
export const autopilotSettleKey = ({
  brandId,
  displayBrandId,
  needed,
  balance,
  price,
}: AutopilotSettleInput): string | null => {
  if (brandId === undefined || brandId !== displayBrandId) return null;
  if (needed === null || balance === null) return null;
  if (autopilotCreditsShortfall({ needed, balance, price }) !== null) return null;
  return `${brandId}|${needed}|${balance}|${price ?? ''}`;
};
